<h2 matDialogTitle>Booking Item</h2>
<form [formGroup]="bookingItemForm" (submit)="save()">
  <mat-dialog-content>
    <div class="edit-dialog" class="flex flex-col justify-start items-stretch  gap-y-2"
      data-cy="edit-booking-item-dialog">
      <h4>Item Details</h4>
      <div class="flex flex-col lg:flex-row justify-start items-stretch lg:items-start gap-y-1">
        <mat-form-field class="lg:basis-1/3 flex-shrink-0">
          <mat-label>Category</mat-label>
          <mat-select placeholder="Category" formControlName="category_id" [testId]="testIds.CATEGORY_SELECT">
            <mat-option *ngFor="let category of categories$ | async" [value]="category?.id">
              {{ category?.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="lg:basis-1/3 flex-shrink-0">
          <mat-label>Product</mat-label>
          <mat-select placeholder="Product" formControlName="product_id" [testId]="testIds.PRODUCT_SELECT">
            <mat-option [value]="null"></mat-option>
            <mat-option *ngFor="let product of products$ | async" [value]="product?.id">
              {{ product?.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="lg:basis-1/3 flex-shrink-0">
          <mat-label>Item</mat-label>
          <mat-select placeholder="Item" formControlName="item_id" [testId]="testIds.ITEM_SELECT">
            <mat-option [value]="null"></mat-option>
            <mat-option *ngFor="let item of items$ | async" [value]="item?.id">
              <span [class]="{ 'text-red-500': item.status !== 'Available' }">{{ item?.code }}
                <ng-container *ngIf="item?.notes">
                  - {{ item?.notes }}</ng-container></span>
            </mat-option>
          </mat-select>
          @if (isVirtualProduct$ | async) {
          <mat-hint>
            Virtual product: assign items when converting to active hire.
          </mat-hint>
          }
        </mat-form-field>
      </div>
      <h4>Hire Details</h4>
      <div
        class="flex flex-col justify-start items-stretch lg:flex-row lg:justify-center lg:items-start lg:gap-x-8 gap-y-0 mb-4 lg:mb-0">
        <mat-form-field class="lg:basis-1/4">
          <mat-label>Quantity</mat-label>
          <input [testId]="testIds.ITEM_QUANTITY" matInput formControlName="quantity" type="number" name="Quantity"
            placeholder="Quantity" />
        </mat-form-field>
        <div fxFlex fxLayout="column">
          <app-booking-item-availability [availability]="availableCount$ | async"
            [quantityRequested]="bookingItemForm.value['quantity']"></app-booking-item-availability>
        </div>
      </div>
      <div class="flex flex-row justify-start items-start">
        <mat-form-field class="mb-4 basis-1/2">
          <mat-label>On hire</mat-label>
          <input [testId]="testIds.ON_HIRE_DATE" matInput [min]="minimumOnHireDate" [max]="maximumOnHireDate$ | async"
            formControlName="on_hire" name="On hire date" [matDatepicker]="onHirePicker" autocomplete="off"
            placeholder="On hire date" />
          <mat-datepicker-toggle matSuffix [for]="onHirePicker"></mat-datepicker-toggle>
          <mat-error *ngIf="
              bookingItemForm.controls['on_hire'].hasError('matDatepickerMin')
            ">
            On hire date can not be less than today's date
          </mat-error>
          <mat-error *ngIf="
              bookingItemForm.controls['on_hire'].hasError('matDatepickerMax')
            ">
            On hire date can not be more than off hire date
          </mat-error>
        </mat-form-field>
        <mat-datepicker #onHirePicker></mat-datepicker>
        <mat-form-field class="basis-1/2">
          <mat-label>On hire time</mat-label>
          <input matInput name="on_hire_time" formControlName="on_hire_time"
            (blur)="updateTimeEnteredManually('on_hire_time', pickerOn)" placeholder="On hire time" />
          <mat-error *ngIf="bookingItemForm.get('on_hire_time').hasError('invalidTime')">Invalid time value, please
            enter in the format: HH:mm (24
            hour)</mat-error>
          <mat-icon matSuffix (click)="pickerOn.open()">access_time</mat-icon>
        </mat-form-field>
        <ngx-mat-timepicker [format]="24" enableKeyboardInput dottedMinutesInGap
          (timeSet)="updateTime($event, 'on_hire_time')" #pickerOn></ngx-mat-timepicker>
      </div>
      <div class="flex flex-row justify-start items-start">
        <mat-form-field class="mb-4 basis-1/2">
          <mat-label>Off hire</mat-label>
          <input [testId]="testIds.OFF_HIRE_DATE" matInput formControlName="off_hire" name="Off hire date"
            autocomplete="off" [min]="minimumOffHireDate$ | async" [matDatepicker]="offHirePicker"
            placeholder="Off hire date" />
          <mat-datepicker-toggle matSuffix [for]="offHirePicker"></mat-datepicker-toggle>
          <mat-error *ngIf="
              bookingItemForm.controls['off_hire'].hasError('matDatepickerMin')
            ">
            Off hire date can not be less than on hire date
          </mat-error>
          <mat-datepicker #offHirePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="basis-1/2">
          <mat-label>Off hire time</mat-label>
          <input matInput name="off_hire_time" formControlName="off_hire_time"
            (blur)="updateTimeEnteredManually('off_hire_time', pickerOff)" placeholder="Off hire time" />
          <mat-error *ngIf="bookingItemForm.get('off_hire_time').hasError('invalidTime')">Invalid time value, please
            enter in the format: HH:mm (24
            hour)</mat-error>
          <mat-icon matSuffix (click)="pickerOff.open()">access_time</mat-icon>
        </mat-form-field>
        <ngx-mat-timepicker [format]="24" enableKeyboardInput dottedMinutesInGap
          (timeSet)="updateTime($event, 'off_hire_time')" #pickerOff></ngx-mat-timepicker>

      </div>
      <div class="flex flex-col md:flex-row justify-start md:items-center items-stretch md:space-x-6 my-4">
        <p><strong>Pricing: </strong>
          @if (pricingType === 'fixed') {
          <span>{{ fixedPrice | hlCurrency:null:1:false | async }}</span>
          } @else {
          <span [matTooltip]="suggestedPrice$ | async | priceEstimateBreakdown">{{ calculatedPrice$ | async |
            hlCurrency:null:1:false | async }}</span>
          <span *ngIf="suggestedPriceError$ | async" class="text-red-500">{{ suggestedPriceError$ | async }}</span>
          }
        </p>
        <app-pricing-type-label [pricingType]="pricingType" [showEditIcon]="false"></app-pricing-type-label>

        <button mat-stroked-button type="button" (click)="openPricingDetails()">Edit Pricing Details</button>
      </div>
      <div
        class="flex flex-col justify-start items-stretch gap-y-2 lg:gap-y-0 lg:flex-row lg:justify-start lg:items-center lg:gap-x-4">
        <mat-radio-group formControlName="collection"
          class="flex flex-row justify-start items-center gap-3 lg:basis-2/3">
          <mat-radio-button [value]="0" data-cy="delivery" [testId]="testIds.DELIVERY_REQUIRED_RB">Delivery required
          </mat-radio-button>
          <mat-radio-button [testId]="testIds.COLLECTION_RB" [value]="1" data-cy="collection">Customer collecting
          </mat-radio-button>
        </mat-radio-group>

        <mat-form-field>
          <mat-label>Collection location</mat-label>
          <mat-select [testId]="testIds.COLLECTION_LOCATION" placeholder="Collect from"
            formControlName="collectionLocation">
            <mat-option *ngFor="let location of locations$ | async" [value]="location.id">
              {{ location.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <mat-form-field class="w-full">
        <mat-label>Additional notes</mat-label>
        <textarea matInput placeholder="Additional notes" formControlName="notes" name="Notes" [testId]="testIds.NOTES"
          cdkTextareaAutosize></textarea>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button (click)="dialogRef.close()" type="button" [testId]="testIds.CANCEL_BUTTON">
      Cancel
    </button>
    <button mat-raised-button [testId]="testIds.SUBMIT_BUTTON" color="primary"
      [disabled]="bookingItemForm.valid !== true || (loading$ | async)" data-cy="save-booking-item" type="submit">
      Save
    </button>
  </mat-dialog-actions>
</form>